!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("webvttPlayer", ["React"], t) : "object" == typeof exports ? exports.webvttPlayer = t(require("react")) : e.webvttPlayer = t(e.React);
}(this, function (e) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 4);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    e.exports = r(2)();
  }, function (e, t, r) {
    "use strict";

    var n = r(3);

    function o() {}

    function a() {}

    a.resetWarningCache = o, e.exports = function () {
      function e(e, t, r, o, a, i) {
        if (i !== n) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var r = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return r.PropTypes = r, r;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(0),
        o = r.n(n),
        a = r(1),
        i = r.n(a);
    r(5);

    function c(e) {
      return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function u(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function s(e) {
      return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function f(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function p(e, t) {
      return (p = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var l = function (e) {
      function t(e) {
        var r, n, o;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), n = this, (r = !(o = s(t).call(this, e)) || "object" !== c(o) && "function" != typeof o ? f(n) : o).state = {
          isActive: !1
        }, r.props.cue.onenter = r.onEnter.bind(f(r)), r.props.cue.onexit = r.onExit.bind(f(r)), r.onClick = r.onClick.bind(f(r)), r;
      }

      var r, n, a;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && p(e, t);
      }(t, e), r = t, (n = [{
        key: "render",
        value: function value() {
          var e = "";
          return this.props.query && this.props.cue.text.match(new RegExp(this.props.query, "i")) ? e = "match" : this.state.isActive && (e = "active"), o.a.createElement("div", {
            className: "".concat(e, " line"),
            onClick: this.onClick
          }, o.a.createElement("div", {
            className: "time"
          }, "[", this.startTime(), " - ", this.endTime(), "]"), o.a.createElement("div", {
            className: "".concat(e, " text"),
            dangerouslySetInnerHTML: {
              __html: this.props.cue.text
            }
          }));
        }
      }, {
        key: "onEnter",
        value: function value() {
          this.setState({
            isActive: !0
          });
        }
      }, {
        key: "onExit",
        value: function value() {
          this.setState({
            isActive: !1
          });
        }
      }, {
        key: "onClick",
        value: function value() {
          this.props.seek(this.props.cue.startTime);
        }
      }, {
        key: "startTime",
        value: function value() {
          return this.formatSeconds(this.props.cue.startTime);
        }
      }, {
        key: "endTime",
        value: function value() {
          return this.formatSeconds(this.props.cue.endTime);
        }
      }, {
        key: "formatSeconds",
        value: function value(e) {
          var t = Math.floor(e / 60);
          t < 10 && (t = "0".concat(t));
          var r = Math.floor(e % 60);
          return r < 10 && (r = "0".concat(r)), "".concat(t, ":").concat(r);
        }
      }]) && u(r.prototype, n), a && u(r, a), t;
    }(o.a.Component);

    l.propTypes = {
      cue: i.a.object,
      seek: i.a.func,
      query: i.a.string
    };
    var y = l;
    r(7);

    function d(e) {
      return (d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function b(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function h(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function m(e, t) {
      return !t || "object" !== d(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function v(e) {
      return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function k(e, t) {
      return (k = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var O = function (e) {
      function t() {
        return b(this, t), m(this, v(t).apply(this, arguments));
      }

      var r, n, a;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && k(e, t);
      }(t, e), r = t, (n = [{
        key: "render",
        value: function value() {
          var e = [];
          if (this.props.track && this.props.track.cues) for (var t = 0; t < this.props.track.cues.length; t++) {
            e.push(o.a.createElement(y, {
              key: "line-".concat(t),
              cue: this.props.track.cues[t],
              active: !1,
              seek: this.props.seek,
              query: this.props.query
            }));
          }
          return o.a.createElement("div", {
            className: "transcript"
          }, e);
        }
      }]) && h(r.prototype, n), a && h(r, a), t;
    }(o.a.Component);

    O.propTypes = {
      track: i.a.object,
      url: i.a.string,
      seek: i.a.func,
      query: i.a.string
    };

    var g = O,
        _ = (r(8), function (e) {
      var t = e.query,
          r = e.updateQuery;
      return o.a.createElement("div", {
        className: "search"
      }, o.a.createElement("div", {
        className: "container"
      }, o.a.createElement("span", {
        className: "icon"
      }, "🔍"), o.a.createElement("input", {
        value: t,
        onChange: function onChange(e) {
          return r(e.target.value);
        }
      })));
    });

    _.propTypes = {
      query: i.a.string,
      updateQuery: i.a.function
    };
    var E = _;
    r(9);

    function j(e) {
      return (j = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function S(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function w(e) {
      return (w = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function T(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function P(e, t) {
      return (P = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var x = function (e) {
      function t() {
        var e, r, n;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), r = this, (e = !(n = w(t).call(this)) || "object" !== j(n) && "function" != typeof n ? T(r) : n).state = {
          loaded: !1,
          currentTime: 0,
          query: ""
        }, e.track = o.a.createRef(), e.audio = o.a.createRef(), e.onLoaded = e.onLoaded.bind(T(e)), e.seek = e.seek.bind(T(e)), e.checkIfLoaded = e.checkIfLoaded.bind(T(e)), e.updateQuery = e.updateQuery.bind(T(e)), e;
      }

      var r, n, a;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && P(e, t);
      }(t, e), r = t, (n = [{
        key: "componentDidMount",
        value: function value() {
          this.checkIfLoaded();
        }
      }, {
        key: "render",
        value: function value() {
          var e = null;
          this.state.loaded && (e = this.track.current.track);
          var t = this.props.preload ? "true" : "false";
          return o.a.createElement("div", {
            className: "webvtt-player"
          }, o.a.createElement("div", {
            className: "media"
          }, o.a.createElement("div", {
            className: "player"
          }, o.a.createElement("audio", {
            controls: !0,
            crossOrigin: "anonymous",
            onLoad: this.onLoaded,
            preload: t,
            ref: this.audio
          }, o.a.createElement("source", {
            src: this.props.audio
          }), o.a.createElement("track", {
            default: !0,
            kind: "subtitles",
            src: this.props.transcript,
            ref: this.track
          }))), o.a.createElement(g, {
            url: this.props.transcript,
            seek: this.seek,
            track: e,
            query: this.state.query
          }), o.a.createElement(E, {
            query: this.state.query,
            updateQuery: this.updateQuery
          })));
        }
      }, {
        key: "onLoaded",
        value: function value() {
          this.setState({
            loaded: !0
          });
        }
      }, {
        key: "checkIfLoaded",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
          e += 1;
          var t = this.track.current;
          if (t && t.track && t.track.cues && t.track.cues.length > 0) this.onLoaded();else if (!this.state.loaded) {
            var r = 25 * Math.pow(e, 2);
            setTimeout(this.checkIfLoaded, r, e);
          }
        }
      }, {
        key: "seek",
        value: function value(e) {
          this.audio.current.currentTime = e, this.audio.current.play();
        }
      }, {
        key: "updateQuery",
        value: function value(e) {
          this.setState({
            query: e
          });
        }
      }]) && S(r.prototype, n), a && S(r, a), t;
    }(o.a.Component);

    x.propTypes = {
      audio: i.a.string,
      transcript: i.a.string,
      preload: i.a.bool,
      query: i.a.string
    };
    var q = x;
    r.d(t, "Player", function () {
      return q;
    });
  }, function (e, t) {},, function (e, t) {}, function (e, t) {}, function (e, t) {}]);
});